__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "international-shipping-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@headlessui/react", "1.7.19", () => (Promise.all([__webpack_require__.e(79), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(6079))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(246), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__(8716))))));
			register("downshift", "9.0.10", () => (Promise.all([__webpack_require__.e(330), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(8330))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(516), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(3516))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(7070))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(166), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(2166))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(318), __webpack_require__.e(676)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("yup", "0.32.11", () => (__webpack_require__.e(467).then(() => (() => (__webpack_require__(3467))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};